import script from "./list-console-slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-console-slug.vue?vue&type=script&setup=true&lang=ts"

import "./list-console-slug.vue?vue&type=style&index=0&id=39b166da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b166da"]])

export default __exports__